import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

const rootElement = document.getElementById('root')
const options = JSON.parse(atob(rootElement.dataset.options))
ReactDOM.render(<App options={options} />, rootElement)
